<app-filter-dropdown
  size="large"
  name="status"
  [value]="statusValue()"
  [placeholder]="'modules.filter.allStatuses' | translate"
  [options]="statusDropdownOptions()"
  (valueChange)="onChange('status', $event)"
/>

<app-filter-dropdown
  size="large"
  name="author"
  [value]="authorValue()"
  [placeholder]="'modules.filter.allOwners' | translate"
  [options]="authorDropdownOptions()"
  (valueChange)="onChange('author', $event)"
/>

<app-tag-filter
  data-testid="modules-tag-filter"
  [tags]="tagOptions()"
  [value]="selectedTags()"
  [ariaLabel]="'modules.filter.tagsAriaLabel' | translate"
  (valueChange)="tagChange.emit($event)"
/>

<app-saved-views-menu
  [views]="savedViews()"
  [activeName]="activeSavedView()"
  [context]="'MODULES'"
  [projectId]="projectId()"
  (viewSelected)="onSavedViewSelected($event)"
  (viewSaved)="onSavedViewSaved($event)"
  (viewDeleted)="onSavedViewDeleted($event)"
  (viewDeleteFailed)="onSavedViewDeleteFailed($event)"
/>

<div class="mod-toolbar-spacer"></div>

@if (hasActiveFilters()) {
  <app-reset-filter-button [label]="'modules.filter.reset' | translate" (resetClick)="resetFilters.emit()" />
}
